<template>
  <div class="companys">
    <div class="banner"></div>

    <!-- 搜索 -->
    <div
      ref="searchBar"
      :class="{ fixedTop: searchBarFixedTop }"
      class="search-wrapper"
    >
      <input-search
        :size="searchBarFixedTop ? 'small' : 'medium'"
        placeholder="搜索公司"
        v-model="searchKeyword"
      ></input-search>
    </div>

    <div class="main clearfix">
      <!-- 条件筛选 -->
      <!-- <div class="screen-wrapper">
        <div class="CationBox">
          <div class="row">
            <div class="name">城市：</div>
            <div class="content">
              <div
                v-for="(item, index) in cityList"
                :key="index"
                @click="submit(item,1)"
                :class="['item', cityVar == item ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
              <div :class="['item', flag ? 'actvCss' : '']" @click="onClick">
                自定义
              </div>
              <div class="item-input" v-if="flag">
                <input type="text" class="input" v-model="city" />
                <el-button type="primary" size="mini" @click="submit(city,2)"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="name">性质：</div>
            <div class="content">
              <div
                v-for="(item, index) in natureList"
                :key="index"
                @click="natureVar = item"
                :class="['item', natureVar == item ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="name">规模：</div>
            <div class="content">
              <div
                v-for="(item, index) in scaleList"
                :key="index"
                @click="scaleVar = item"
                :class="['item', scaleVar == item ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div
            class="screen-row"
            v-if="
              (cityVar != '全部' && cityVar != '') ||
              natureVar != '全部' ||
              scaleVar != '全部'
            "
          >
            <div class="name">已选择：</div>
            <div class="content">
              <div
                class="item actvCss"
                v-if="cityVar != '全部' && cityVar != ''"
                @click="clearCity"
              >
                {{ cityVar }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <div
                class="item actvCss"
                v-if="natureVar != '全部'"
                @click="natureVar = '全部'"
              >
                {{ natureVar }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <div
                class="item actvCss"
                v-if="scaleVar != '全部'"
                @click="scaleVar = '全部'"
              >
                {{ scaleVar }}<i class="el-icon-close el-icon--right"></i>
              </div>
            </div>
            <div>
              <el-button
                type="text"
                icon="el-icon-delete-solid"
                @click="clearFilter"
                >清空筛选条件</el-button
              >
            </div>
          </div>
        </div>
      </div> -->
      <!-- 主体内容 -->
      <div class="content" v-loading:#ffffff7d.scrollFixed="loading">
        <ul class="content-list">
          <li
            class="recommend-company-item"
            v-for="(item, index) in companyList"
            :key="index"
          >
            <a :href="'/companyDetail/' + item.reCompanyId" target="_blank">
              <!-- <router-link :to="'/companyDetail/' + item.reCompanyId"> -->
              <div class="company-top-container">
                <div class="company-top">
                  {{ item.reCompanyName }}
                </div>
                <div class="company-bottom substring">
                  <span class="tag" v-if="item.industry">{{
                    item.industry
                  }}</span
                  ><span class="tag" v-if="item.enterpriseNature">{{
                    item.enterpriseNature
                  }}</span
                  ><span class="tag" v-if="item.enterpriseScale">{{
                    item.enterpriseScale
                  }}</span>
                  <span class="tag" v-if="item.groupName">{{
                    item.groupName
                  }}</span>
                </div>
              </div>
              <!-- </router-link> -->
            </a>
          </li>
        </ul>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryFilter.pageNum"
            :limit.sync="queryFilter.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOffsetTop } from "@/helper/utilities";
let positionY = 0;
let searchBarClientHeight = 0;
import { getCompanyList } from "@/api/index.js";
export default {
  name: "companys",
  data() {
    return {
      // cityList: [
      //   "全部",
      //   "北京",
      //   "上海",
      //   "广州",
      //   "深圳",
      //   "杭州",
      //   "苏州",
      //   "南京",
      //   "武汉",
      //   "西安",
      //   "重庆",
      //   "成都",
      //   "大连",
      // ],
      // natureList: [
      //   "全部",
      //   "国有企业",
      //   "事业单位",
      //   "上市公司",
      //   "私营企业",
      //   "其他",
      // ],
      // scaleList: [
      //   "全部",
      //   "20人以下",
      //   "20-99人",
      //   "100-199人",
      //   "200-499人",
      //   "500人以上",
      // ],
      flag: false,
      // cityVar: "全部",
      // city: "",
      // natureVar: "全部",
      // scaleVar: "全部",
      companyList: [],
      // 查询参数
      searchKeyword: "",
      currentPage: 1,
      // 总条数
      total: 0,
      searchBarFixedTop: false,
      loading: false,
    };
  },
  computed: {
    queryFilter() {
      return {
        pageNum: 1,
        pageSize: 10,
        search: this.searchKeyword || "",
        orderByColumn: "create_time",
        isAsc: "desc",
      };
    },
  },
  watch: {
    queryFilter(newVal, oldVal) {
      this.searchBarFixedTop && window.scrollTo(0, positionY);
      this.getList();
    },
  },
  mounted() {
    this.$nextTick(() => {
      positionY = getOffsetTop(document.body, this.$refs.searchBar);

      searchBarClientHeight = this.$refs.searchBar.clientHeight;
    });
    const onPageScroll = () => {
      const top = this.$refs.searchBar.getBoundingClientRect().top;

      this.searchBarFixedTop =
        window.scrollY > positionY - searchBarClientHeight / 2;
    };
    window.addEventListener("scroll", onPageScroll);

    this.$on("hook:destroyed", () => {
      window.removeEventListener("scroll", onPageScroll);
    });
  },
  created() {
    this.getList();
  },
  methods: {
    // clearFilter() {
    //   this.flag = false;
    //   this.cityVar = "全部";
    //   this.city = "";
    //   this.natureVar = "全部";
    //   this.scaleVar = "全部";
    // },

    // clearCity() {
    //   this.flag = false;
    //   this.cityVar = "全部";
    //   this.city = "";
    // },

    // onClick() {
    //   this.flag = true;
    //   this.cityVar = "";
    // },

    // submit(item,stuats) {
    //   if (item == "全部") {
    //     this.flag = false;
    //     this.city = "";
    //   } else if(stuats == 1) {
    //     this.flag = false;
    //   }
    //   this.cityVar = item;
    // },

    getList() {
      const loading = this.$loading();
      getCompanyList(this.queryFilter)
        .then((response) => {
          loading.close();
          this.companyList = response.data;
          this.total = response.total;
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.companys {
  background-color: #f3f3f3;
  padding-bottom: 30px;
}
.banner {
  padding-bottom: 32%;
  line-height: 400px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../assets/images/yssdpc.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}
.search-wrapper {
  // position: absolute;
  width: 100%;
  // padding: 0 200px;
  transform: translateY(-50%);
  z-index: 100;
  &.fixedTop {
    position: fixed;
    box-shadow: 0 5px 4px rgba(0, 0, 0, 0.1);
    top: 0;
    padding: 20px 130px;
    z-index: 1000;
    background-color: #fff;
    transform: translateY(0);
  }
}

.main {
  width: @main-width;
  margin: 0 auto;
  .screen-wrapper {
    width: @main-width;
    padding: 0 auto;
    .CationBox {
      width: @main-width;
      background-color: #fff;
      border-radius: 4px;
      padding: 30px 32px 18px;
    }
    .row > div {
      flex-shrink: 0;
      margin-right: 30px;
      font-size: 14px;
    }
    .row {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-bottom: 1px solid #f3f3f3;
    }
    .content {
      flex: 1;
      display: flex;
      .item {
        border-radius: 3px;
        color: #666;
        padding: 5px 15px;
        margin: 5px 0;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        border: 1px solid transparent;
      }
      .item-input {
        margin-left: 20px;
        margin: 5px 10px;
        display: flex;
        justify-content: center;
        .input {
          width: 100px;
          height: 31px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
      .actvCss {
        background: #39b8ff;
        color: #fff;
      }
    }
    .screen-row > div {
      flex-shrink: 0;
      margin-right: 15px;
      font-size: 14px;
    }
    .screen-row {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      .item {
        margin: 0 10px;
      }
    }
  }
  .content-list {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .recommend-company-item:nth-child(2n) {
      margin-right: 0;
    }
    .recommend-company-item {
      background-color: #fff;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      margin-bottom: 21px;
      margin-right: 20px;
      padding: 13px 27px;
      width: 45%;
    }

    .company-top-container {
      line-height: 30px;
    }

    .substring {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      text-align: left;
    }
    .tag {
      font-size: 14px;
    }
    .tag:not(:first-child):before {
      content: "|";
      margin: 0 4px;
    }
  }

  .pagination-wrapper {
    text-align: center;
  }
}
</style>
